import { render, staticRenderFns } from "./SectorButton.vue?vue&type=template&id=0f73bab9&"
import script from "./SectorButton.vue?vue&type=script&lang=ts&"
export * from "./SectorButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports